export default "__VITE_ASSET__BcsV1BBI__"